import { useEffect, useRef, useState } from "react"
import Network from "../../utils/Network"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"

const Invite = props => {
    const { t } = useTranslation()
    const [isExpair, setIsExpair] = useState(false)
    const [inviteInfo, setInviteInfo] = useState(null)
    const [errorText, setErrorText] = useState('')
    const openAppTimer = useRef(0)
    const location = useLocation()
    const getInfo = async () => {
        const sceneCode = location.search.substring(1)
        if (!sceneCode) {
            setIsExpair(true)
            setErrorText(t('link_data_error'))
            return
        }
        try {
            const url = 'https://gateway-cn.moshontek.com/portal/share/analysisShortUrl'
            const params = {
                sceneCode: sceneCode.replace('=', '')
            }
            const result = await Network.get(url, params)
            console.log('analysisShortUrl result: ', result)
            setInviteInfo(result.shareInfo)
            setIsExpair(false)
            setErrorText('')
        } catch (error) {
            console.log('analysisShortUrl error: ', error)
            setIsExpair(true)
            if (error.code != 40013) {
                setErrorText(t('link_data_error'))
            } else {
                setErrorText(t('link_expair'))
            }
        }

    }

    const _objectToQueryString = (obj) => {
        return Object.keys(obj).map(key => {
            return ''.concat(encodeURIComponent(key), '=').concat(encodeURIComponent(obj[key]));
        }).join('&');
    }

    const onPageBlur = () => {
        clearTimeout(openAppTimer.current)
    }

    useEffect(() => {
        console.log('code: ', location.search.substring(1))
        window.onblur = onPageBlur
        getInfo()
    }, [])
    return <div className="App">
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', alignItems: 'center' }}>
            <div style={{ display: 'flex', height: 44, width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                <span style={{ fontSize: 17, color: '#333333', fontWeight: '500' }}>{t('device_share')}</span>
            </div>
            {
                isExpair ?
                    <div style={{ marginTop: 150, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <img alt="" style={{ width: 100, height: 100 }} src="https://moshontek-prod-cn.oss-cn-beijing.aliyuncs.com/webH5/page_invalid.png" />
                        <span style={{ fontSize: 14, color: '#999999', marginTop: 10 }}>{errorText}</span>
                    </div>
                    :
                    inviteInfo ?
                        <div style={{ marginTop: 26, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <img alt="" src={inviteInfo.deviceIcon} />
                            <span style={{ marginTop: 32, fontSize: 15, fontWeight: 'bold', color: '#000000' }}>{inviteInfo.deviceName}</span>
                            <span style={{ color: '#666666', fontSize: 13, marginTop: 5 }}>{inviteInfo.sourceMobile + ' ' + t('device_share_message')}</span>
                            <div className="goto_app" onClick={() => {
                                const params = {
                                    mxId: inviteInfo.id,
                                    shareId: inviteInfo.shareId,
                                    deviceUuid: inviteInfo.deviceUuid,
                                    targetMobile: inviteInfo.targetMobile,
                                    sourceMobile: inviteInfo.sourceMobile,
                                    deviceName: inviteInfo.deviceName
                                }
                                const paramsStr = _objectToQueryString(params)
                                const universalLink = 'https://safety.moshontek.com/home.html?' + paramsStr
                                console.log('universalLink: ', universalLink)
                                const userAgent = navigator.userAgent;
                                const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1; //android终端
                                if (isAndroid) {
                                    const schemeUrl = 'magicq3://safety.moshontek.com?' + paramsStr
                                    window.location.href = schemeUrl
                                    clearTimeout(openAppTimer.current)
                                    openAppTimer.current = setTimeout(() => {
                                        window.location.href = universalLink
                                    }, 1000)
                                } else {
                                    window.location.href = universalLink
                                }

                            }}>
                                <span style={{ fontSize: 15, color: '#FFFFFF', fontWeight: '500' }}>{t('goto_app')}</span>
                            </div>
                        </div> : null
            }
        </div>
    </div>
}

export default Invite